import { render, staticRenderFns } from "./ColumnContainer.vue?vue&type=template&id=0a7f608c&scoped=true&lang=pug"
import script from "./ColumnContainer.vue?vue&type=script&lang=js"
export * from "./ColumnContainer.vue?vue&type=script&lang=js"
import style0 from "./ColumnContainer.vue?vue&type=style&index=0&id=0a7f608c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f608c",
  null
  
)

export default component.exports